import React from "react";

const RiskMatrix = () => {
  return (
    <div className="container mt-5">
      <h4 className="text-center mb-4">Risikomatrix</h4>
      <table className="table table-bordered text-center">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">Geringe Auswirkung</th>
            <th scope="col">Mittlere Auswirkung</th>
            <th scope="col">Hohe Auswirkung</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">Hohe Wahrscheinlichkeit</th>
            <td className="bg-warning fw-semibold fs-5 text-dark">Mittel</td>
            <td className="bg-orange fw-semibold fs-5 text-dark">Hoch</td>
            <td className="bg-danger fw-semibold fs-5 text-dark">Sehr hoch</td>
          </tr>
          <tr>
            <th scope="row">Mittlere Wahrscheinlichkeit</th>
            <td className="bg-success fw-semibold fs-5 text-dark">Niedrig</td>
            <td className="bg-warning fw-semibold fs-5 text-dark">Mittel</td>
            <td className="bg-orange fw-semibold fs-5 text-dark">Hoch</td>
          </tr>
          <tr>
            <th scope="row">Geringe Wahrscheinlichkeit</th>
            <td className="bg-success fw-semibold fs-5 text-dark">Niedrig</td>
            <td className="bg-success fw-semibold fs-5 text-dark">Niedrig</td>
            <td className="bg-warning fw-semibold fs-5 text-dark">Mittel</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default RiskMatrix;
